import React, { useState, useEffect } from "react";

export default function ClubFinanceApp() {
  const images = [
    `${process.env.PUBLIC_URL}/Finance-App.png`,
  ];

  const [currentImage, setCurrentImage] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % images.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <div
      className="min-h-screen flex flex-col bg-gray-900 text-white px-8 pt-20"
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL}/Finance.png)`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="flex-grow flex md:flex-row items-stretch justify-center gap-12 px-2 md:px-8 pt-20 md:flex mb-20">
        <div className="w-full md:w-1/2 hidden md:flex justify-center items-stretch">
          <img
            src={images[currentImage]}
            alt="Club Finance App"
            className="w-full h-full rounded-2xl shadow-lg object-cover transition duration-1000"
          />
        </div>
        <div className="bg-black/60 backdrop-blur-md p-8 rounded-2xl shadow-lg w-auto flex flex-col justify-center">
          <h1 className="text-3xl md:text-4xl font-bold text-purple-400 mb-6">Club Finance App</h1>
          <p className="text-gray-300 leading-relaxed text-lg mb-4">
            Built a financial management application tailored for student clubs to handle budgets, expenses, and financial reporting.
          </p>
          <ul className="list-disc list-outside pl-6 text-gray-300 leading-relaxed text-lg space-y-4">
            <li>Application Development: Designed and implemented a user-friendly finance tracker using Python and SQLite.</li>
            <li>Budget Management: Allowed clubs to manage multiple budgets, track expenses, and generate financial summaries.</li>
            <li>Data Visualization: Included clear financial charts and reports to support informed decision-making.</li>
            <li>Security: Implemented basic authentication and data validation to ensure secure financial records.</li>
          </ul>
          <p className="text-gray-300 leading-relaxed text-lg mt-4">
            Enabled student clubs to maintain transparent and efficient financial management practices.
          </p>
        </div>
      </div>
    </div>
  );
}